import React from 'react';
import clsx from 'clsx';
import { PropTypes } from 'prop-types';
import IconContainer from '../IconContainer';
import * as twitterStyles from '../../../styles/widgets/twitter.module.scss';

const Twitter = ({tweet, column, row}) => {
  const tweetItem = {};

  tweetItem.id = tweet?.retweet ? tweet?.retweetIdStringFormat : tweet?.idStringFormat;

  tweetItem.userName = tweet?.retweet ? tweet?.retweetedStatus?.user?.name : tweet?.user?.name;

  tweetItem.userScreenName = tweet?.retweet ?
    tweet?.retweetedStatus?.user?.screenName : tweet?.user?.screenName;

  const handleClick = () => {
    if (typeof window !== 'undefined')
      window.open(`https://twitter.com/${tweetItem.userScreenName}/status/${tweetItem.id}`, '_blank');
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (typeof window !== 'undefined')
        window.open(`https://twitter.com/${tweetItem.userScreenName}/status/${tweetItem.id}`, '_blank');
    }
  };

  tweetItem.tweetText = tweet?.text
    .replace(tweet?.text.match(/https:\/\/t\.co\/\S+\s*$/g), '')
    .replace(tweet?.text.match(/RT @\S+ /g), '');
  return (
    <div className={twitterStyles.bloc}>
      <div
        style={{
          paddingBottom: `calc((100% / ${column}) * (${row}))`,
          gridArea: '1 / 1 / -1 / -1'
        }}
      />
      <div className={twitterStyles.innerBloc}>
        <button
          aria-label={tweetItem.userName + ' @' + tweetItem.userScreenName + ' ' + tweetItem.tweetText}
          className={twitterStyles.itemBloc}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          rel="noreferrer"
        >
          {tweet?.retweet && (
            <div className={twitterStyles.containerRetweet}>
              <IconContainer
                classname={twitterStyles.logoRetweet}
                icon={'TWITTER_RETWEET'}
                size="20"
                tabIndex={-1}
              />
              <p
                className={clsx(twitterStyles.retweet, twitterStyles.nbLinesTop)}
              >
                {tweet?.user?.name} a retweeté
              </p>
            </div>
          )}
          <div className={twitterStyles.containerContent}>
            <div
              className={twitterStyles.content}
            >
              <p
                className={clsx(twitterStyles.screenName, twitterStyles.nbLinesTop)}
              >
                {tweetItem.userName}
              </p>
              <IconContainer
                classname={twitterStyles.logo}
                icon={'TWITTER'}
                size={30}
                tabIndex={-1}
              />
              <div className={twitterStyles.contentId}>
                <p
                  className={twitterStyles.id}
                >
                    @{tweetItem.userScreenName}
                </p>
              </div>
            </div>
          </div>
          <div className={twitterStyles.contentHashtag}>
            <p
              className={clsx(twitterStyles.text, twitterStyles.nbLines)}
            >
              {tweetItem.tweetText}
            </p>
            {tweet?.hashtagEntities.map((hashtag, index) => (
              <p
                className={twitterStyles.hashtag}
                key={index}
              >
                #{hashtag.text}&nbsp;
              </p>))}
          </div>
        </button>
      </div>
    </div>
  );
};

Twitter.propTypes = {
  column: PropTypes.number,
  row: PropTypes.number,
  tweet: PropTypes.shape({
    retweet: PropTypes.bool,
    retweetIdStringFormat: PropTypes.string,
    idStringFormat: PropTypes.string,
    user: PropTypes.shape({
      name: PropTypes.string,
      screenName: PropTypes.string,
    }),
    retweetedStatus: PropTypes.shape({
      user: PropTypes.shape({
        name: PropTypes.string,
        screenName: PropTypes.string,
      }),
    }),
    text: PropTypes.string,
    hashtagEntities: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
    })),
  })
};

export default Twitter;
